$(document).ready(function () {
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
});

$(document).ready(function () {
  $('.iframe').fancybox({
    modal: true,
    toolbar: true,
    smallBtn: true,
    preload: false,
    infocus: true,
    autoFocus: false,
    showCloseButton: true,
    closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
    ajax: {
      preload: false,
    },
  });
});

$(document).ready(function() {
  if (window.themeJsData.templateName !== 'product') {
    localStorage.removeItem("product-click");
  }
  localStorage.setItem("checkout-value",1);
  if (window.themeJsData.cartItemCount <= 0) {
    localStorage.setItem("cart",null);
    localStorage.removeItem("cart_updated");
    localStorage.removeItem("search_value");
  }
  var pageName=window.location.href;
  $(document).on("click", ".disable-btn", function(event) {
    event.preventDefault()
  });
  $(document).on("click", ".product-scratch-list", function(e) {
    var item_id = $(this).find('.frequent-products-mpn').val();
    var item_name = $(this).find('.frequent-products-tittlr').val();
    var item_category = $(this).find('.item_category').val();
    if (pageName.includes("products")) {
      var mpn_handle = $("#mpn_handle").val();
      var item_list_page = "ATTACH :: " + mpn_handle;
    } else if (pageName.includes("cart")) {
      var item_list_page = "ATTACH :: Cart Page";
    } else {
      var item_list_page = "ATTACH :: " + formatString($(this).find('.item_list_page').val());
    }
    var currency = $(this).find('.item_currency').val();
    var price = $(this).find('.item_price').val();
    var item_sku = $(this).find('.list-sku').val();
    var productcomPrice = $(this).find('.item_compare_price').val();
    localStorage.setItem("product-click", item_list_page);
    var productPrice = Number(price.replace(/[^0-9.-]+/g, ""));
    var  discount = 0;
    if (productcomPrice) {
      productcomPrice = Number(productcomPrice.replace(/[^0-9.-]+/g, ""));
      if (productcomPrice > productPrice) {
        discount = parseFloat(productcomPrice) - parseFloat(productPrice);
        discount = parseFloat(discount);
        //  productPrice = productcomPrice;
      }
    }
    dataLayer.push({
      'ecommerce': null
    });
    dataLayer.push({
      'event': 'select_item',
      'ecommerce': {
        'item_list_name': item_list_page,
        'items': [{
          'item_id': item_sku,
          'item_name': item_name,
          'item_category': item_category,
          'item_list_name': item_list_page,
          'price': parseFloat(productPrice),
          'quantity': 1
        }]
      }
    });
  });

  $(document).on("click", ".predictive-search__results-list .predictive-search__list-item--product", function(e) {
    localStorage.setItem("product-click", "Search Quick View");
  });

  $(document).on("click", ".predictive-search__search-for-button, .predictive-search__results-list .predictive-search__list-item--suggestions", function(e) {
    localStorage.setItem("product-click", "Search Results");
  });

  $(document).on("click", ".plp_page_ga", function(e) {
    localStorage.setItem("product-click", "PLP :: " + formatString(pageName.split("/")[pageName.split("/").length - 1]));
  });


  var attch_prod = [];
  $('.product-list-contain').each(function(key, val) {
    var id = $(this).attr('id');
    var sliderId = '#' + id;
    var item_list_name = "";
    var productPrice = 0;
    var discount = 0;
    var prodQuant = 1;
    $(sliderId + " li").each(function(key1, val) {
      item_ga = {}
      productPrice = $(this).find('.item_price').val()
      productcomPrice = $(this).find('.item_compare_price').val();
      if (productPrice) productPrice = Number(productPrice.replace(/[^0-9.-]+/g, ""));
      discount = 0;
      if (productcomPrice) {
        productcomPrice = Number(productcomPrice.replace(/[^0-9.-]+/g, ""));
        if (productcomPrice > productPrice) {
          discount = parseFloat(productcomPrice) - parseFloat(productPrice);
          discount = parseFloat(discount);
          value_price = productcomPrice * parseInt(prodQuant);
          //productPrice = productcomPrice;
        }
      }
      item_ga["item_id"] = $(this).find('.list-sku').val();
      item_ga["item_name"] = $(this).find('.frequent-products-tittlr').val();
      item_ga["item_category"] = $(this).find('.item_category').val();

      if (pageName.includes("products")) {
        var mpn_handle = $("#mpn_handle").val();
        item_list_name = "ATTACH :: " + mpn_handle;
      } else if (pageName.includes("cart")) {
        item_list_name = "ATTACH :: Cart Page";
      } else {
        item_list_name = "ATTACH :: " + formatString($(this).find('.item_list_page').val());
      }
      item_ga["item_list_name"] = item_list_name;
      item_ga["price"] = parseFloat(productPrice);
      item_ga["quantity"] = 1;
      attch_prod.push(item_ga);

    });
    if (attch_prod.length != 0) {
      dataLayer.push({
        'ecommerce': null
      });
      dataLayer.push({
        'event': 'view_item_list',
        'ecommerce': {
          'item_list_name': item_list_name,
          'items': attch_prod
        }
      });
    }
    attch_prod = [];
  });

  $("#cart-notification").hide();
  $('#cart-notification').removeClass('minicart-active');
  $('#cart-icon-bubble').click(function(evt){
    evt.stopPropagation();
    $('#cart-notification').toggle();
    $('#cart-notification').toggleClass('minicart-active');
    $('#cart-notification .minicart_close')?.focus();
  });
  $('#close-cart').click(function(evt){
    $("#cart-notification").hide();
    $('#cart-notification').removeClass('minicart-active');
  });
});

window.mobileSearchNormalLayout = true;
window.autocompleteFormSelector = '.mob_search:visible, .search-modal__form:visible';

$(document).on('click', '.card-slider-buttons_2', function (e) {
  e.preventDefault(); // stops the buttons behavior
  /* Order Product Limits - Karthikeyan */
  var prodId = $(this).attr('data-productid');
  var prodQuant = 1;
  var prodMaxqut = $(this).attr('data-productmaxquantity');
  if (prodMaxqut != '') {
    var maxQuant = checkMaxquantity(prodId);
    if (maxQuant != '') {
      var max_total_quantity = parseInt(prodQuant) + parseInt(maxQuant);
    } else {
      var max_total_quantity = parseInt(prodQuant);
    }
    if (max_total_quantity > prodMaxqut) {
      alert(quantity_limit_error_message);
      return false;
    }
  }
  var slider_variantid = $('.prod_details_' + prodId)
    .find(':selected')
    .val();
  var slider_tag = $(this).attr('data-tag');
  var main_product_sku = $(this).attr('data-productsku');
  var productList = $(this).attr('data-productlist');
  var productCategory = $(this).attr('data-producttype');
  var productPrice = $(this).attr('data-productprice');
  var productCurrency = $(this).attr('data-productcurrency');
  var productTitle = $(this).attr('data-producttitle');
  var prohandle = $(this).attr('data-producthandle');
  var mpnHandle = $(this).attr('data-productMPN');
  var mpnHandleVariant = '';
  $('#slider-form-' + slider_variantid).attr('aria-disabled', true);
  $('#slider-form-' + slider_variantid).addClass('loading');
  $('.loading-overlay__spinner-frequent').removeClass('hidden');
  var viewurl = `${window.Shopify.routes.root}products/' + prohandle + '?variant=' + slider_variantid + '&view=mpn`;
  $.ajax({
    type: 'GET',
    url: viewurl,
    async: false,
    success: function (itemData) {
      let arrprod = itemData.split('|');
      if (mpnHandle.length == 0) {
        if (arrprod[1] != '') {
          mpnHandleVariant = arrprod[1];
        } else {
          mpnHandleVariant = arrprod[0];
        }
      } else {
        mpnHandleVariant = mpnHandle;
      }
      productPrice = arrprod[2];
    },
  });
  mpnHandleVariant = mpnHandleVariant.trim();
  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'post',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      items: [
        {
          id: slider_variantid,
          quantity: 1,
          properties: {
            _uuid: prohandle,
          },
        },
      ],
    }),
  })
    .then((response) => {
      response.json().then((d) => {
        var productList = 'Search Results';
        cartCookie(mpnHandleVariant, d.items[0].key, productList);
      });
      checkQuantity();

      //souvik code for product list tracking starts
      triggerGAAddToCart(
        mpnHandleVariant,
        productTitle,
        productCategory,
        productList,
        productCurrency,
        productPrice,
        prodQuant,
        main_product_sku,
        slider_variantid
      );
      //souvik code for product list tracking ends
      $.get(`${window.Shopify.routes.root}cart?view=minicart`, function (itemData) {
        var item_count = jQuery(itemData).find('#cart-notification-button .count').text();
        if ($('.cart-count-bubble').length > 0) {
          $('.cart-count-bubble span').text(item_count);
        } else {
          $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span></span></div>');
          $('.cart-count-bubble span').text(item_count);
        }
        $('#cart-notification').text('');
        var textreplace = "<div id='min-cart-replace'></div>";
        $('#cart-notification').append(textreplace);
        $('#cart-notification').replaceWith(itemData);
        $('#cart-notification').addClass('minicart-active');
      });
      $('#slider-form-' + slider_variantid).attr('aria-disabled', false);
      $('#slider-form-' + slider_variantid).removeClass('loading');
      $('.loading-overlay__spinner-frequent').addClass('hidden');
    })
    .catch((error) => {
      console.log('Error:', error);
      return false;
    });
  return false;
});
//localStorage.clear();
//localStorage.removeItem('cart');
//localStorage.removeItem("search_value");
var pageName = window.location.href;
if (pageName.includes('search')) {
  var urlParams = new URLSearchParams(window.location.search);
  var search_term_str = urlParams.get('q');
  var search_term = formatString(search_term_str);
  localStorage.setItem('search_value_term', search_term);
  var first_search = localStorage.getItem('search_value');
  $('.product-grid').each(function (key, val) {
    var item_list_name = 'Search Results';
    var productPrice = 0;
    var discount = 0;
    var prodQuant = 1;
    $('.product-grid li').each(function (key1, val) {
      item_ga = {};
      productPrice = $(this).find('.item_price').val();
      productcomPrice = $(this).find('.item_compare_price').val();
      if (productPrice) productPrice = Number(productPrice.replace(/[^0-9.-]+/g, ''));
      discount = 0;
      if (productcomPrice) {
        productcomPrice = Number(productcomPrice.replace(/[^0-9.-]+/g, ''));
        if (productcomPrice > productPrice) {
          discount = parseFloat(productcomPrice) - parseFloat(productPrice);
          discount = parseFloat(discount);
          value_price = productcomPrice * parseInt(prodQuant);
          //productPrice = productcomPrice;
        }
      }
      item_ga['item_id'] = $(this).find('.list-sku').val();
      item_ga['item_name'] = $(this).find('.frequent-products-tittlr').val();
      item_ga['item_category'] = $(this).find('.item_category').val();
      item_ga['item_list_name'] = item_list_name;
      item_ga['price'] = parseFloat(productPrice);
      item_ga['quantity'] = 1;
      dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          search_term: search_term,
          item_list_name: 'Search Results',
          items: [item_ga],
        },
      });
    });
  });
}
function formatString(str) {
  if (!str) return str;
  return str
    .replace(/(\B)[^ ]*/g, (match) => match.toLowerCase())
    .replace(/^[^ ]/g, (match) => match.toUpperCase());
}

function cartCookie(mpnHandleVariant, prodVariantID, productList) {
  if (first_search == null) {
    localStorage.setItem('search_value', search_term);
    var first_search_str = localStorage.getItem('search_value');
    first_search = formatString(first_search_str);
  }

  var exphone = [];
  var item_cart = {};
  item_cart['cart_item_id'] = prodVariantID;
  item_cart['cart_item_list_name'] = productList;
  item_cart['cart_search_term'] = first_search;
  item_cart['cart_item_mpn'] = mpnHandleVariant;
  if (JSON.parse(localStorage.getItem('cart')) != undefined) {
    exphone = JSON.parse(localStorage.getItem('cart'));
  }
  exphone.push(item_cart);
  localStorage.setItem('cart', JSON.stringify(exphone));
}

//souvik code for sending product List starts
function triggerGAAddToCart(
  prodVariantID,
  productTitle,
  productCategory,
  productList,
  productCurrency,
  productPrice,
  prodQuant,
  main_product_sku,
  slider_variantid
) {
  if (first_search == null) {
    localStorage.setItem('search_value', search_term);
    var first_search_str = localStorage.getItem('search_value');
    first_search = formatString(first_search_str);
  }
  if (productPrice) productPrice = Number(productPrice.replace(/[^0-9.-]+/g, ''));
  var discount = 0;
  var prodQuant = 1;
  var productCurrency = window.themeJsData.shopCurrency;
  var value_price = productPrice * parseInt(prodQuant);
  var value_price1 = parseFloat(value_price);
  var productPrice1 = parseFloat(productPrice);
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      search_term: search_term,
      currency: productCurrency,
      value: value_price1,
      item_list_name: 'Search Results',
      currency: window.themeJsData.shopCurrency,
      items: [
        {
          item_id: main_product_sku,
          item_name: productTitle,
          item_category: productCategory,
          price: productPrice,
          quantity: 1,
        },
      ],
    },
  });
}

//souvik code for sending product List ends

$(document).ready(function () {
  function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  var template1 = window.themeJsData.templateStrip;
  // erase 4th variant option cookies and cookie array, if template isnot product
  if (template1 != 'product') {
    eraseCookie('option1select');
    eraseCookie('option2select');
    eraseCookie('option3select');
    eraseCookie('optionPIDlist');
  }
});

// Eplehuset

// Zendesk launcher
$(document).ready(function () {
  let isMessengerOpen = false;
    
  // Sync with real state from Zendesk events
  zE('messenger:on', 'open', () => {
    isMessengerOpen = true;
    $('#launcher').show();
  });

  zE('messenger:on', 'close', () => {
    isMessengerOpen = false;
    $('#launcher').hide();
  });

  document.getElementById('epleZdCustomLauncher').addEventListener('click', function () {
    if (isMessengerOpen) {
      zE('messenger', 'close');
    } else {
      zE('messenger', 'open');
    }
  });
})

// Two.inc company search for B2B registration
try {
  (() => {
    if (!window.location.href.includes('b2b-kontoregistrering')) return;

    console.log('[CompanyAutocomplete] Loaded');

    // === CONFIG ===
    const CONFIG = {
      debounceDelay: 300,
      apiKey: 'secret_test_LHnG8PuAwA4p_jmLqVn0r80lsn490sTCz4jkrpuW0LU',
      searchUrl: 'https://api.two.inc/companies/v2/company',
      detailUrl: (id) => `https://api.two.inc/companies/v2/company/${id}`,
      shadowSelectors: {
        host: '#app-embed',
        companyInput: '#company_name',
        taxId: '#company_tax_id',
        recipient: '#shipping_address_recipient',
        address1: '#shipping_address_address1',
        zip: '#shipping_address_zip',
        city: '#shipping_address_city',
      }
    };

    // === API SERVICE ===
    const CompanyService = {
      async search(query) {
        const url = `${CONFIG.searchUrl}?company_type=UNDEFINED&country=NO&limit=15&q=${encodeURIComponent(query)}`;
        const res = await fetch(url);
        return res.json();
      },
      async fetchDetails(id) {
        const res = await fetch(CONFIG.detailUrl(id), {
          headers: { 'X-Api-Key': CONFIG.apiKey }
        });
        return res.json();
      }
    };

    // === FIELD POPULATOR ===
    const FieldPopulator = {
      setInput(shadowRoot, selector, value) {
        const el = shadowRoot.querySelector(selector);
        if (el) {
          el.value = value ?? '';
          el.dispatchEvent(new Event('input', { bubbles: true }));
        }
      },
      populate(shadowRoot, data) {
        this.setInput(shadowRoot, CONFIG.shadowSelectors.taxId, data.national_identifier?.id);
        this.setInput(shadowRoot, CONFIG.shadowSelectors.recipient, data.name);
        this.setInput(shadowRoot, CONFIG.shadowSelectors.address1, data.addresses?.[0]?.street_address);
        this.setInput(shadowRoot, CONFIG.shadowSelectors.zip, data.addresses?.[0]?.postal_code);
        this.setInput(shadowRoot, CONFIG.shadowSelectors.city, data.addresses?.[0]?.city);
      }
    };

    // === AUTOCOMPLETE CLASS ===
    class CompanyAutocomplete {
      constructor(shadowRoot) {
        this.shadowRoot = shadowRoot;
        this.input = shadowRoot.querySelector(CONFIG.shadowSelectors.companyInput);
        this.menu = null;
        this.items = [];
        this.highlightedIndex = -1;
        this.suppressNextInput = false;
        this.debounceTimer = null;

        this.bindEvents();
      }

      bindEvents() {
        this.input.addEventListener('input', (e) => this.handleInput(e));
        this.input.addEventListener('keydown', (e) => this.handleKeyDown(e));
        this.input.addEventListener('blur', () => setTimeout(() => this.closeMenu(), 200));
      }

      handleInput(e) {
        if (this.suppressNextInput) {
          this.suppressNextInput = false;
          return;
        }

        const query = e.target.value.trim();
        if (this.debounceTimer) clearTimeout(this.debounceTimer);

        this.debounceTimer = setTimeout(() => {
          if (query.length > 1) {
            this.fetchAndRenderSuggestions(query);
          } else {
            this.closeMenu();
          }
        }, CONFIG.debounceDelay);
      }

      async fetchAndRenderSuggestions(query) {
        try {
          const data = await CompanyService.search(query);
          this.items = data.items || [];
          this.renderMenu();
        } catch (err) {
          console.error('Search error:', err);
        }
      }

      renderMenu() {
        if (!this.menu) this.createMenu();
        this.menu.innerHTML = '';
        this.highlightedIndex = -1;

        if (this.items.length === 0) {
          this.addMenuItem('No results', null, true);
          return;
        }

        this.items.forEach((item, i) => {
          this.addMenuItem(
            `${item.name} <span style="color: #888;">(${item.national_identifier.id})</span>`,
            () => this.selectItem(i)
          );
        });

        this.positionMenu();
      }

      createMenu() {
        this.menu = document.createElement('div');
        Object.assign(this.menu.style, {
          position: 'absolute',
          border: '1px solid #ccc',
          background: '#fff',
          zIndex: 9999,
          maxHeight: '200px',
          overflowY: 'auto',
          fontSize: '14px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        });
        this.shadowRoot.appendChild(this.menu);
      }

      addMenuItem(html, onClick, disabled = false) {
        const item = document.createElement('div');
        item.innerHTML = html;
        item.style.padding = '8px';
        item.style.cursor = disabled ? 'default' : 'pointer';
        item.style.borderBottom = '1px solid #eee';
        if (!disabled) {
          item.classList.add('autocomplete-item');
          item.addEventListener('mousedown', (e) => {
            e.preventDefault(); // avoid input blur
            onClick();
          });
        } else {
          item.style.color = '#888';
        }
        this.menu.appendChild(item);
      }

      positionMenu() {
        const rect = this.input.getBoundingClientRect();
        this.menu.style.top = `${rect.bottom + window.scrollY}px`;
        this.menu.style.left = `${rect.left + window.scrollX}px`;
        this.menu.style.width = `${rect.width}px`;
      }

      highlight(index) {
        const items = this.menu.querySelectorAll('.autocomplete-item');
        items.forEach((el, i) => {
          el.style.background = i === index ? '#f0f0f0' : '#fff';
        });
      }

      async selectItem(index) {
        const item = this.items[index];
        if (!item) return;
        this.suppressNextInput = true;
        this.input.value = item.name;
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
        this.closeMenu();

        try {
          const details = await CompanyService.fetchDetails(item.lookup_id);
          FieldPopulator.populate(this.shadowRoot, details);
        } catch (err) {
          console.error('Detail fetch error:', err);
        }
      }

      closeMenu() {
        if (this.menu) this.menu.innerHTML = '';
        this.items = [];
        this.highlightedIndex = -1;
      }

      handleKeyDown(e) {
        const maxIndex = this.items.length - 1;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (this.highlightedIndex < maxIndex) {
            this.highlightedIndex++;
            this.highlight(this.highlightedIndex);
          }
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          if (this.highlightedIndex > 0) {
            this.highlightedIndex--;
            this.highlight(this.highlightedIndex);
          }
        } else if (e.key === 'Enter') {
          e.preventDefault();
          if (this.highlightedIndex >= 0) {
            this.selectItem(this.highlightedIndex);
          }
        } else if (e.key === 'Escape') {
          this.closeMenu();
        }
      }
    }

    // === WAIT FOR SHADOW HOST & INPUT TO BE READY ===
    const waitForInputField = () => {
      const host = document.querySelector(CONFIG.shadowSelectors.host);
      if (!host || !host.shadowRoot) return null;

      const input = host.shadowRoot.querySelector(CONFIG.shadowSelectors.companyInput);
      return input ? host.shadowRoot : null;
    };

    const initWhenReady = () => {
      const interval = setInterval(() => {
        const shadowRoot = waitForInputField();
        if (shadowRoot) {
          clearInterval(interval);
          new CompanyAutocomplete(shadowRoot);
        }
      }, 300);
    };

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      initWhenReady();
    } else {
      document.addEventListener('DOMContentLoaded', initWhenReady);
    }
  })();
} catch (err) {
  console.error('[CompanyAutocomplete] Init error:', err);
}
